import axios from "axios";

const baseUrl = () => {
  if (process.env.REACT_APP_NODE_ENV === "development") {
    return process.env.REACT_APP_API_DEV_URL;
  } else if (process.env.REACT_APP_NODE_ENV === "production") {
    return process.env.REACT_APP_API_PROD_URL;
  }
};

const adminURL = "http://192.168.1.14:5001";

const API = axios.create({
  baseURL: baseUrl(),
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

const APIAdmin = axios.create({
  baseURL: baseUrl(),
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

const APILocal = axios.create({
  baseURL: adminURL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

const APIFile = axios.create({
  baseURL: baseUrl(),
  headers: {
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": "*",
  },
});

// It helps to send Token through headers
API.interceptors.request.use((req) => {
  if (localStorage?.getItem("token")) {
    req.headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
  }
  return req;
});

APILocal.interceptors.request.use((req) => {
  if (localStorage?.getItem("admin_token")) {
    req.headers["Authorization"] = `Bearer ${localStorage.getItem(
      "admin_token"
    )}`;
  }
  return req;
});

// It helps to send admin Token through headers
APIAdmin.interceptors.request.use((req) => {
  if (localStorage?.getItem("admin_token")) {
    req.headers["Authorization"] = `Bearer ${localStorage.getItem(
      "admin_token"
    )}`;
  }
  return req;
});

// It helps to send admin Token through headers
APILocal.interceptors.request.use((req) => {
  if (localStorage?.getItem("superadmin_token")) {
    req.headers["Authorization"] = `Bearer ${localStorage.getItem(
      "superadmin_token"
    )}`;
  }
  return req;
});

// It helps to send Token through headers
APIFile.interceptors.request.use((req) => {
  if (localStorage?.getItem("admin_token")) {
    req.headers["Authorization"] = `Bearer ${localStorage.getItem(
      "admin_token"
    )}`;
  }
  return req;
});

// currencies or token apis
export const GetRWACategories = () =>
  API.get(`api/currencies/rwa/categories?page=${2}&size=${10}`);
export const GetRWACurrencies = (data) =>
  API.get(
    `/api/currencies?page=${data.page}&size=${data.size}&category=${
      data.category ? data.category : ""
    }&sortBy=${data.sortBy ? data.sortBy : ""}&order=${
      data.sortDirection ? data.sortDirection : ""
    }`
  );
export const TokenDetails = (data) =>
  API.get(`api/currencies/rwa/coin/${data}`);
export const HighlightsRWAData = () => API.get(`/api/currencies/rwa/highlight`);
export const TrendingData = () => API.get("/api/currencies/rwa/trend");
export const CoinGraphData = (data) =>
  API.get(`/api/currencies/rwa/graph/coinOHLC/${data}`);
export const GetBlog = (data) => API.get("/api/currencies/rwa/blog");
export const GetBlogPagination = (data) =>
  API.get(`/api/currencies/rwa/blog?page=${data.page}&size=${data.size}`);
export const GetNews = () => API.get("/api/currencies/rwa/news");
export const GetNewsDetails = (data) =>
  API.get(`/api/currencies/rwa/news/${data}`);

// user apis
export const GetVerifyEmail = (data) => API.get(`/api/users/verify/${data}`);
export const UserSignUp = (data) => API.post("/api/users/signup", data);
export const UserLogin = (data) => API.post("/api/users/signin", data);
export const ResetPassword = (data) =>
  API.post(`/api/users/reset-password/${data.token}`, data.pass);
export const ForgotPassword = (data) =>
  API.post("/api/users/forgot-password", data);

// user token apis
export const FavCoin = (data) => API.get(`/api/users/fav/coin/${data}`);
export const AddToken = (data) => APIFile.post("/api/user/token/add/new", data);

export const AddTokenPortfolio = (data) =>
  API.get(`api/user/token/add/portfolio/${data}`);

export const GetUserToken = () => API.get(`/api/user/token/portfolio`);
export const PostUserTransaction = (data) =>
  API.post(`/api/user/token/portfolio/${data.id}`, data);

// SuperAdmin login API
export const SuperAdminLoginAPI = (data) =>
  APIAdmin.post("/api/admin/users/signin", data);

// Admin login API (Need to be changed)
export const AdminLoginAPI = (data) =>
  APIAdmin.post("/api/admin/users/signin", data);

// Add new Admins
export const AddAdminAPI = (data) =>
  APIAdmin.post("/api/admin/users/add", data);

// Admin News
export const AdminNewsFetch = (data) =>
  APIAdmin.get(
    `/api/admin/news?page=${data.page}&size=${data.size}&filter=${data.filter}`
  );

export const AdminAddNewsPost = (data) =>
  APIFile.post("/api/admin/news/add", data);

export const AdminUpdateNews = (slug, data) =>
  APIFile.patch(`/api/admin/news/update/${slug}`, data);

export const AdminDeleteNews = (id) =>
  APIAdmin.delete(`/api/admin/news/delete/${id}`);

// Admin Blog
export const AdminAddBlog = (data) => APIFile.post("/api/admin/blog/add", data);

export const AdminUpdateBlog = (slug, data) =>
  APIFile.patch(`/api/admin/blog/update/${slug}`, data);

export const AdminBlogFetch = (data) =>
  APIAdmin.get(
    `/api/admin/blog?page=${data.page}&size=${data.size}&filter=${data.filter}`
  );

export const AdminDeleteBlogs = (id) =>
  APIAdmin.delete(`/api/admin/blog/delete/${id}`);

// admin dashboard apis
export const GetAllTokenAdmin = (data) =>
  APIAdmin.get(
    `/api/admin/token?page=${data.page}&size=${data.size}&sortBy=market_cap_rank&order=asc&filter=${data.filter}`
  );

export const AdminReviewAPI = (coinId, data) =>
  APIAdmin.post(`/api/admin/review/add/${coinId}`, data);

export const GetAllReviewsAdmin = () => APIAdmin.get(`/api/admin/review/`);

export const updateCoinDetails = (coinId, formData) =>
  APIFile.patch(`/api/admin/token/update/${coinId}`, formData);

export const GetUpdatedCoinDetails = (coinId, data) =>
  APIAdmin.get(`/api/admin/token/update/${coinId}`, data);

export const EnableDisableAdminCoin = (coinId, data) =>
  APIAdmin.patch(`/api/admin/token/toggle/${coinId}`, data);
